/*
    Add here your own custom javascript
*/
// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()


document.addEventListener('DOMContentLoaded', function() {

    // Inyectar CSS agresivo en el <head>
    var style = document.createElement('style');
    style.innerHTML = `
        .appstle_tooltip_appstle {
            display: none !important;
            visibility: hidden !important;
            opacity: 0 !important;
        }
    `;
    document.head.appendChild(style);

    // Función para ocultar el tooltip si aparece
    function ocultarTooltip() {
        var tooltips = document.querySelectorAll('.appstle_tooltip_appstle');
        tooltips.forEach(function(tooltip) {
            tooltip.style.display = 'none';
            tooltip.style.visibility = 'hidden';
            tooltip.style.opacity = '0';
        });
    }

    // Ejecutar ocultarTooltip periódicamente por si Appstle lo muestra después
    setInterval(ocultarTooltip, 500);

    // Observador de mutaciones para detectar si se crea el tooltip en el DOM
    const observer = new MutationObserver(function(mutationsList) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                ocultarTooltip(); // Intentar ocultarlo inmediatamente
            }
        }
    });

    // Iniciar la observación en el body
    observer.observe(document.body, { childList: true, subtree: true });
});


/* FUNCIONES ADD TO CART */
  function adjustIconsOnStickyATC() {
    const stickyATC = document.getElementById('sticky-atc');
    const honeypopButton = document.querySelector('#honeypop-app button');
    const shopifyChat = document.querySelector('#shopify-chat inbox-online-store-chat');

    if (!stickyATC || !honeypopButton || !shopifyChat) return;

    // Guardar la posición inicial REAL de cada uno
    const originalBottomHoneypop = getComputedStyle(honeypopButton).bottom;
    const originalBottomChat = getComputedStyle(shopifyChat).bottom;

    // Asegura transiciones suaves
    honeypopButton.style.transition = 'bottom 0.3s ease';
    shopifyChat.style.transition = 'bottom 0.3s ease';

    function updatePositions() {
      if (stickyATC.classList.contains('show')) {
        const offset = stickyATC.offsetHeight + 16;
        honeypopButton.style.bottom = offset + 'px';
        shopifyChat.style.setProperty('bottom', offset + 'px', 'important');
      } else {
        honeypopButton.style.bottom = originalBottomHoneypop;
        shopifyChat.style.setProperty('bottom', originalBottomChat, 'important');
      }
    }

    const observer = new MutationObserver(updatePositions);
    observer.observe(stickyATC, {
      attributes: true,
      attributeFilter: ['class']
    });

    updatePositions();
  }

  document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 768 && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return;
  }
  
    const interval = setInterval(() => {
      const sticky = document.getElementById('sticky-atc');
      const honeypopButton = document.querySelector('#honeypop-app button');
      const shopifyChat = document.querySelector('#shopify-chat inbox-online-store-chat');

      if (sticky && honeypopButton && shopifyChat) {
        clearInterval(interval);
        adjustIconsOnStickyATC();
      }
    }, 300);

    setTimeout(() => clearInterval(interval), 10000);
  });


/* aquí next */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a.btn-arriba').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      var target = document.querySelector('.product-buy-buttons');
      if (target) {
        // Calcula la posición para centrar el bloque en el viewport
        var rect = target.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var targetY = rect.top + scrollTop - (viewportHeight / 2) + (rect.height / 2);

        window.scrollTo({
          top: targetY,
          behavior: 'smooth'
        });
      }
    });
  });
});

/* FIN AJUSTES ADD TO CART */

// BOTONES PRELOADER
document.addEventListener('DOMContentLoaded', function() {
  var preloader = document.getElementById('add-to-cart-preloader');
  var btn = document.querySelector('button.btn-atc[type="submit"]');
  if (btn) {
    btn.addEventListener('click', function(){
      preloader.style.display = 'flex';
    });
  }
});

// PATCH UNIVERSAL PARA OCULTAR EL PRELOADER AL FINALIZAR /cart/add.js
(function() {
  var preloader = document.getElementById('add-to-cart-preloader');

  // PATCH PARA fetch
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function() {
      var fetchArgs = arguments;
      var url = (fetchArgs[0] && fetchArgs[0].toString()) || '';
      if (url.indexOf('/cart/add') !== -1) {
        return originalFetch.apply(this, arguments).then(function(response) {
          if (preloader) preloader.style.display = 'none';
          return response;
        }).catch(function(err){
          if (preloader) preloader.style.display = 'none';
          throw err;
        });
      } else {
        return originalFetch.apply(this, arguments);
      }
    }
  }

  // PATCH PARA XMLHttpRequest (por si acaso)
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._isAddToCart = url.indexOf('/cart/add') !== -1;
    return originalOpen.apply(this, arguments);
  };

  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    if (this._isAddToCart) {
      this.addEventListener('loadend', function() {
        if (preloader) preloader.style.display = 'none';
      });
    }
    return originalSend.apply(this, arguments);
  };
})();

// FAQ
document.addEventListener('click', function(event) {
  
  var faqLink = event.target.closest('#faq-link');
  if (faqLink) {
    event.preventDefault();
    var faqModal = document.getElementById('faq-modal');
    if (faqModal) faqModal.style.display = 'flex';
    return;
  }

  var closeFaqModal = event.target.closest('#close-faq-modal');
  if (closeFaqModal) {
    event.preventDefault();
    var faqModal = document.getElementById('faq-modal');
    if (faqModal) faqModal.style.display = 'none';
    return;
  }

  var faqModal = document.getElementById('faq-modal');
  if (faqModal && event.target === faqModal) {
    faqModal.style.display = 'none';
  }

}, true); // ← CAPTURE MODE OBLIGATORIO





/* ********************************* */
/* OCULTA BOTÓN COMPRA CUANDO HAY QUANTITY BREAK 
/* ********************************** */
/*document.addEventListener("DOMContentLoaded", function () {
  const targetNode = document.body;

  const OFFER_BOX_SELECTOR = ".qbk-product-offer .qbk-offer-box";
  const APPSTLE_SELECTOR   = ".appstle_subscription_wrapper";
  const BUTTON_SELECTOR    = ".product-buy-buttons-inner";

  function applyRule() {
    const hasOfferBox = document.querySelector(OFFER_BOX_SELECTOR) !== null;
    const hasAppstle  = document.querySelector(APPSTLE_SELECTOR) !== null;

    document.querySelectorAll(BUTTON_SELECTOR).forEach(btn => {
      // ✅ Regla:
      // si hay qbk-offer-box y NO hay appstle → ocultar
      // resto → mostrar
      if (hasOfferBox && !hasAppstle) {
        btn.style.display = "none";
      } else {
        btn.style.display = "";
      }
    });
  }

  // 1) al cargar
  applyRule();

  // 2) si se inyecta después
  new MutationObserver(applyRule).observe(targetNode, {
    childList: true,
    subtree: true,
  });
});*/
/* ********************************** */

/* ********************************** */
/* PRECIOS DTO FINDE DE SEMANA
/* ********************************** */


/* ************************************** */
/* PRECIOS DTO COMPRA ÚNICA + SUSCRIPCIÓN */
/* ************************************** */

(function() {
  var FECHA_EXPIRACION = '2025-11-09T23:59:59';
  var DESCUENTO        = 0.85; // 15% descuento
  var FECHA_INICIO = '2025-01-01T00:00:00';

  var ahora = new Date();
  var inicio = new Date(FECHA_INICIO);
  var fin = new Date(FECHA_EXPIRACION);

  // Si estamos fuera del rango, no ejecutar nada
  if (ahora < inicio || ahora > fin) return;

  // Inyecta los estilos CSS
  ;(function injectCSS() {
    if (!document.getElementById('hide-appstle-strike-style')) {
      var style = document.createElement('style');
      style.id = 'hide-appstle-strike-style';
      style.innerHTML = `
        /* Oculta únicamente los spans tachados dentro del contenedor de suscripción */
        .appstle_subscription_radio_wrapper .appstle_subscription_amount.transcy-money span[style*="line-through"] {
          display: none !important;
        }
        
        /* Badge de descuento */
        .col-desc-badge {
          display: inline-block;
          background: #c00;
          color: white;
          padding: 2px 8px;
          border-radius: 4px;
          font-size: 0.7em;
          font-weight: bold;
          margin-left: 8px;
          vertical-align: middle;
        }
        
        /* Countdown timer */
        .col-desc-countdown {
          display: block;
          font-size: 0.75em;
          color: #666;
          margin-top: 4px;
          font-weight: normal;
        }
        .qbk-product-offer{display:none !important;}
      `;
      document.head.appendChild(style);
    }
  })();

  // Función para calcular el porcentaje de descuento
  function calcularPorcentajeDesc(multiplicador) {
    return Math.round((1 - multiplicador) * 100);
  }

  // Función para actualizar el countdown
  function actualizarCountdown(elem) {
    var ahora = new Date().getTime();
    var fin = new Date(FECHA_EXPIRACION).getTime();
    var diff = fin - ahora;
    
    if (diff <= 0) {
      elem.textContent = 'Oferta finalizada';
      return;
    }
    
    var dias = Math.floor(diff / (1000 * 60 * 60 * 24));
    var horas = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutos = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var segundos = Math.floor((diff % (1000 * 60)) / 1000);
    
    var texto = '';
    if (dias > 0) {
      texto = dias + 'd ' + horas + 'h ' + minutos + 'm';
    } else if (horas > 0) {
      texto = horas + 'h ' + minutos + 'm ' + segundos + 's';
    } else {
      texto = minutos + 'm ' + segundos + 's';
    }
    
    elem.textContent = '⏱️ Termina en: ' + texto;
  }

  function actualizarPreciosYOcultarWrappers() {
    // 0) Salir si la promo expiró
    if (new Date() > new Date(FECHA_EXPIRACION)) return;
    
    var porcentaje = calcularPorcentajeDesc(DESCUENTO);

    // 1) Compra única + one-time Appstle
    document.querySelectorAll(
      '.product-price-final, .product-item-price-final, ' +
      '.appstle_one_time_price_wrapper .appstle_subscription_amount'
    ).forEach(function(priceElem) {
      if (!priceElem.innerHTML.includes('line-through')) {
        var originalText  = priceElem.textContent.trim();
        var originalPrice = parseFloat(originalText.replace('€','').replace(',','.'));
        if (!isNaN(originalPrice)) {
          var discounted = (originalPrice * DESCUENTO).toFixed(2).replace('.', ',');
          
          // Crear badge si no existe
          var badge = priceElem.nextElementSibling;
          if (!badge || !badge.classList.contains('col-desc-badge')) {
            badge = document.createElement('span');
            badge.className = 'col-desc-badge';
            badge.textContent = '-' + porcentaje + '%';
            priceElem.parentNode.insertBefore(badge, priceElem.nextSibling);
            
            // Crear countdown
            var countdown = document.createElement('span');
            countdown.className = 'col-desc-countdown';
            badge.parentNode.insertBefore(countdown, badge.nextSibling);
            
            // Actualizar countdown cada segundo
            actualizarCountdown(countdown);
            setInterval(function() {
              actualizarCountdown(countdown);
            }, 1000);
          }
          
          priceElem.innerHTML =
            '<span style="text-decoration: line-through; color: #888; font-size:0.7em !important">' + originalText + '</span> ' +
            '<span style="color: #c00; font-weight: bold;">' + discounted + '€</span>';
        }
      }
    });

    // 2) Suscripción Appstle: aplicar 15% sobre el precio actual
    document.querySelectorAll('#appstle_subscription_widget0 .appstle_subscription_amount').forEach(function(priceElem) {
      if (!priceElem.innerHTML.includes('line-through')) {
        var originalText  = priceElem.textContent.trim();
        var originalPrice = parseFloat(originalText.replace('€','').replace(',','.'));
        if (!isNaN(originalPrice)) {
          var discounted = (originalPrice * DESCUENTO).toFixed(2).replace('.', ',');
          
          // Crear badge si no existe
          var badge = priceElem.nextElementSibling;
          if (!badge || !badge.classList.contains('col-desc-badge')) {
            badge = document.createElement('span');
            badge.className = 'col-desc-badge';
            badge.textContent = '-' + porcentaje + '%';
            priceElem.parentNode.insertBefore(badge, priceElem.nextSibling);
            
            // Crear countdown
            var countdown = document.createElement('span');
            countdown.className = 'col-desc-countdown';
            badge.parentNode.insertBefore(countdown, badge.nextSibling);
            
            // Actualizar countdown cada segundo
            actualizarCountdown(countdown);
            setInterval(function() {
              actualizarCountdown(countdown);
            }, 1000);
          }
          
          priceElem.innerHTML =
            '<span style="text-decoration: line-through; color: #888; font-size:0.7em !important">' + originalText + '</span> ' +
            '<span style="color: #c00; font-weight: bold;">' + discounted + '€</span>';
        }
      }
    });
  }

  // Ejecutar en carga y tras cambios dinámicos
  if (new Date() <= new Date(FECHA_EXPIRACION)) {
    document.addEventListener('DOMContentLoaded', actualizarPreciosYOcultarWrappers);
    new MutationObserver(actualizarPreciosYOcultarWrappers)
      .observe(document.body, { childList: true, subtree: true });
  }
})();

/* ********************************** */
/* PRECIOS DTO COMPRA ÚNICA           */
/* Solo mientras esté dentro de la fecha */
/* ********************************** */

var FECHA_EXPIRACION_UNICA = '2025-06-22T23:59:59';
var DESCUENTO_UNICA        = 0.85; // 15% dto

function actualizarPreciosUnica() {
  // 0) Si ya expiró, salimos
  if (new Date() > new Date(FECHA_EXPIRACION_UNICA)) return;

  // 1) Aplicar descuento a compra única y one-time Appstle
  document.querySelectorAll(
    '.product-price-final, .product-item-price-final, ' +
    '.appstle_one_time_price_wrapper .appstle_subscription_amount'
  ).forEach(function(elem) {
    // evitar dobles pasadas
    if (!elem.innerHTML.includes('line-through')) {
      var txt = elem.textContent.trim();
      var num = parseFloat(txt.replace('€','').replace(',','.'));
      if (!isNaN(num)) {
        var dto = (num * DESCUENTO_UNICA).toFixed(2).replace('.', ',');
        elem.innerHTML =
          '<span style="text-decoration: line-through; color:#888;">' + txt + '</span> ' +
          '<span style="color:#c00;font-weight:bold">'        + dto + '€</span>';
      }
    }
  });

  // 2) (Opcional) ocultar precio Appstle dentro del widget
  // document.querySelectorAll('#appstle_subscription_widget0 .appstle_subscription_amount')
  //   .forEach(el => el.style.display = 'none');
}

// Ejecutar solo si no ha expirado la promo
if (new Date() <= new Date(FECHA_EXPIRACION_UNICA)) {
  document.addEventListener('DOMContentLoaded', actualizarPreciosUnica);
  new MutationObserver(actualizarPreciosUnica)
    .observe(document.body, { childList: true, subtree: true });
}



/* ********************************** */
/* PRECIOS 4X3 FIN DE SEMANA        */
/* ********************************** */
var FECHA_EXPIRACION_4X3 = '2025-07-20T23:59:59';

function anadirAviso4x3() {
  // Verificar si ha expirado
  if (new Date() > new Date(FECHA_EXPIRACION_4X3)) {
    return;
  }

  // Añade (4x3 EN TODO) si no existe ya
  document.querySelectorAll(
    '.product-price-final, .product-item-price-final'
  ).forEach(function(priceElem) {
    if (!priceElem.textContent.includes('4x3 EN TODO')) {
      priceElem.innerHTML += ' <span style="color:#c00; font-size:0.8em;font-weight:bold">(4x3 EN TODO)</span>';
    }
  });
}

// Ejecutar solo si no ha expirado
if (new Date() <= new Date(FECHA_EXPIRACION_4X3)) {
  document.addEventListener('DOMContentLoaded', anadirAviso4x3);
  var observer = new MutationObserver(anadirAviso4x3);
  observer.observe(document.body, { childList: true, subtree: true });
}

/* ************************************** */
/* PRECIOS DTO POR COLECCIONES ESPECÍFICAS */
/* ************************************** */

(function() {
  var FECHA_EXP_COL = '2025-10-26T23:59:59';
  
  var DESC_COLECCIONES = {
    'fitstyle': 0.87,  // 13% descuento
    'match': 0.80      // 20% descuento
  };

  console.log('[COLECCIONES] Script cargado');

  function getDescProducto(productElement) {
    var collections = productElement.getAttribute('data-product-collections');
    if (!collections) return null;
    
    var colArray = collections.toLowerCase().split(',');
    var descuentos = [];
    
    for (var col in DESC_COLECCIONES) {
      if (colArray.indexOf(col) !== -1) {
        descuentos.push(DESC_COLECCIONES[col]);
      }
    }
    
    return descuentos.length > 0 ? Math.min.apply(null, descuentos) : null;
  }

  function getDescPaginaProducto() {
    // Método 1: Desde meta.product.collections
    if (typeof meta !== 'undefined' && meta.product && meta.product.collections) {
      console.log('[COLECCIONES] Leyendo desde meta.product');
      for (var i = 0; i < meta.product.collections.length; i++) {
        var colHandle = meta.product.collections[i].handle.toLowerCase();
        if (DESC_COLECCIONES.hasOwnProperty(colHandle)) {
          console.log('[COLECCIONES] Encontrado en meta:', colHandle);
          return DESC_COLECCIONES[colHandle];
        }
      }
    }
    
    // Método 2: Desde JSON-LD breadcrumb
    var jsonLd = document.querySelector('script[type="application/ld+json"]');
    if (jsonLd) {
      try {
        var data = JSON.parse(jsonLd.textContent);
        if (data.itemListElement) {
          console.log('[COLECCIONES] Leyendo desde JSON-LD');
          for (var i = 0; i < data.itemListElement.length; i++) {
            var item = data.itemListElement[i];
            if (item.item && item.item.includes('/collections/')) {
              var handle = item.item.split('/collections/')[1].toLowerCase();
              if (DESC_COLECCIONES.hasOwnProperty(handle)) {
                console.log('[COLECCIONES] ✓ Encontrado:', handle);
                return DESC_COLECCIONES[handle];
              }
            }
          }
        }
      } catch(e) {
        console.log('[COLECCIONES] Error al leer JSON-LD:', e);
      }
    }
    
    // Método 3: Desde breadcrumbs del DOM
    var breadcrumbLinks = document.querySelectorAll('.breadcrumb a[href*="/collections/"]');
    if (breadcrumbLinks.length > 0) {
      console.log('[COLECCIONES] Leyendo desde breadcrumb DOM');
      for (var i = 0; i < breadcrumbLinks.length; i++) {
        var href = breadcrumbLinks[i].getAttribute('href');
        var handle = href.split('/collections/')[1].split('/')[0].split('?')[0].toLowerCase();
        if (DESC_COLECCIONES.hasOwnProperty(handle)) {
          console.log('[COLECCIONES] ✓ Encontrado:', handle);
          return DESC_COLECCIONES[handle];
        }
      }
    }
    
    console.log('[COLECCIONES] No se encontró descuento');
    return null;
  }

  // Función para calcular el porcentaje de descuento
  function calcularPorcentajeDesc(multiplicador) {
    return Math.round((1 - multiplicador) * 100);
  }

  // Función para actualizar el countdown
  function actualizarCountdown(elem) {
    var ahora = new Date().getTime();
    var fin = new Date(FECHA_EXP_COL).getTime();
    var diff = fin - ahora;
    
    if (diff <= 0) {
      elem.textContent = 'Oferta finalizada';
      return;
    }
    
    var dias = Math.floor(diff / (1000 * 60 * 60 * 24));
    var horas = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutos = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var segundos = Math.floor((diff % (1000 * 60)) / 1000);
    
    var texto = '';
    if (dias > 0) {
      texto = dias + 'd ' + horas + 'h ' + minutos + 'm';
    } else if (horas > 0) {
      texto = horas + 'h ' + minutos + 'm ' + segundos + 's';
    } else {
      texto = minutos + 'm ' + segundos + 's';
    }
    
    elem.textContent = '⏱️ Termina en: ' + texto;
  }

  (function() {
    if (!document.getElementById('css-col-desc')) {
      var s = document.createElement('style');
      s.id = 'css-col-desc';
      s.innerHTML = `
        .appstle_subscription_radio_wrapper .appstle_subscription_amount.transcy-money span[style*="line-through"] {
          display: none !important;
        }
        .col-desc-badge {
          display: inline-block;
          background: #c00;
          color: white;
          padding: 2px 8px;
          border-radius: 4px;
          font-size: 0.7em;
          font-weight: bold;
          margin-left: 8px;
          vertical-align: middle;
        }
        .col-desc-countdown {
          display: block;
          font-size: 0.75em;
          color: #666;
          margin-top: 4px;
          font-weight: normal;
        }
      `;
      document.head.appendChild(s);
    }
  })();

  function aplicarDescCol() {
    if (new Date() > new Date(FECHA_EXP_COL)) return;
    
    var url = window.location.pathname;
    
    // PÁGINA DE PRODUCTO
    if (url.includes('/products/')) {
      var desc = getDescPaginaProducto();
      if (!desc) return;
      
      var porcentaje = calcularPorcentajeDesc(desc);
      
      // 1) Compra única + one-time Appstle
      document.querySelectorAll(
        '.product-price-final, ' +
        '.appstle_one_time_price_wrapper .appstle_subscription_amount'
      ).forEach(function(priceElem) {
        if (!priceElem.innerHTML.includes('line-through')) {
          var originalText = priceElem.textContent.trim();
          var originalPrice = parseFloat(originalText.replace('€','').replace(',','.'));
          if (!isNaN(originalPrice)) {
            var discounted = (originalPrice * desc).toFixed(2).replace('.', ',');
            
            // Crear badge si no existe
            var badge = priceElem.nextElementSibling;
            if (!badge || !badge.classList.contains('col-desc-badge')) {
              badge = document.createElement('span');
              badge.className = 'col-desc-badge';
              badge.textContent = '-' + porcentaje + '%';
              priceElem.parentNode.insertBefore(badge, priceElem.nextSibling);
              
              // Crear countdown
              var countdown = document.createElement('span');
              countdown.className = 'col-desc-countdown';
              badge.parentNode.insertBefore(countdown, badge.nextSibling);
              
              // Actualizar countdown cada segundo
              actualizarCountdown(countdown);
              setInterval(function() {
                actualizarCountdown(countdown);
              }, 1000);
            }
            
            priceElem.innerHTML =
              '<span style="text-decoration: line-through; color: #888; font-size:0.7em !important">' + originalText + '</span> ' +
              '<span style="color: #c00; font-weight: bold;">' + discounted + '€</span>';
          }
        }
      });

      // 2) Suscripción Appstle
      document.querySelectorAll('#appstle_subscription_widget0 .appstle_subscription_amount').forEach(function(priceElem) {
        if (!priceElem.innerHTML.includes('line-through')) {
          var originalText = priceElem.textContent.trim();
          var originalPrice = parseFloat(originalText.replace('€','').replace(',','.'));
          if (!isNaN(originalPrice)) {
            var discounted = (originalPrice * desc).toFixed(2).replace('.', ',');
            
            // Crear badge si no existe
            var badge = priceElem.nextElementSibling;
            if (!badge || !badge.classList.contains('col-desc-badge')) {
              badge = document.createElement('span');
              badge.className = 'col-desc-badge';
              badge.textContent = '-' + porcentaje + '%';
              priceElem.parentNode.insertBefore(badge, priceElem.nextSibling);
              
              // Crear countdown
              var countdown = document.createElement('span');
              countdown.className = 'col-desc-countdown';
              badge.parentNode.insertBefore(countdown, badge.nextSibling);
              
              // Actualizar countdown cada segundo
              actualizarCountdown(countdown);
              setInterval(function() {
                actualizarCountdown(countdown);
              }, 1000);
            }
            
            priceElem.innerHTML =
              '<span style="text-decoration: line-through; color: #888; font-size:0.7em !important">' + originalText + '</span> ' +
              '<span style="color: #c00; font-weight: bold;">' + discounted + '€</span>';
          }
        }
      });
      
      return;
    }
    
    // LISTADO DE PRODUCTOS
    document.querySelectorAll('.product-item[data-product-collections]').forEach(function(item) {
      var desc = getDescProducto(item);
      if (!desc) return;
      
      var porcentaje = calcularPorcentajeDesc(desc);
      var priceElem = item.querySelector('.product-item-price-final');
      
      if (priceElem && !priceElem.innerHTML.includes('line-through')) {
        var originalText = priceElem.textContent.trim();
        var originalPrice = parseFloat(originalText.replace('€','').replace(',','.'));
        if (!isNaN(originalPrice)) {
          var discounted = (originalPrice * desc).toFixed(2).replace('.', ',');
          
          // Crear badge si no existe
          var badge = priceElem.nextElementSibling;
          if (!badge || !badge.classList.contains('col-desc-badge')) {
            badge = document.createElement('span');
            badge.className = 'col-desc-badge';
            badge.textContent = '-' + porcentaje + '%';
            priceElem.parentNode.insertBefore(badge, priceElem.nextSibling);
            
            // Crear countdown
            var countdown = document.createElement('span');
            countdown.className = 'col-desc-countdown';
            badge.parentNode.insertBefore(countdown, badge.nextSibling);
            
            // Actualizar countdown cada segundo
            actualizarCountdown(countdown);
            setInterval(function() {
              actualizarCountdown(countdown);
            }, 1000);
          }
          
          priceElem.innerHTML =
            '<span style="text-decoration: line-through; color: #888; font-size:0.7em !important">' + originalText + '</span> ' +
            '<span style="color: #c00; font-weight: bold;">' + discounted + '€</span>';
        }
      }
    });
  }

  if (new Date() <= new Date(FECHA_EXP_COL)) {
    console.log('[COLECCIONES] ✓ Promoción activa');
    document.addEventListener('DOMContentLoaded', aplicarDescCol);
    new MutationObserver(aplicarDescCol).observe(document.body, { childList: true, subtree: true });
  }
})();


// =============================
// BADGE 30% 2ª UNIDAD — versión compacta en móvil
// (variables/funciones 100% distintas a las del otro script)
// =============================

// Config
var FECHA_FIN_SEGUNDA_BIS   = '2025-10-13T23:59:59';
var TEXTO_BADGE_DESKTOP_BIS = '30% en 2ª ud, ¡combinable!';
var TEXTO_BADGE_MOVIL_BIS   = '30% 2ª ud';
var CLASE_BADGE_SEG_BIS     = 'badge-2aud-bis';
var OBJETIVOS_BADGE_BIS     = '.product-price-final, .product-item-price-final, .price, .product-info, .product-card, .appstle_one_time_price_wrapper';
var ATRIBUTO_INYECTADO_BIS  = 'data-badge-2aud-bis';

// Umbrales y tamaños móviles
var ANCHO_MOVIL_MAX_BIS     = 480; // px
var TAM_FUENTE_DESKTOP_BIS  = 12;  // px
var TAM_FUENTE_MOVIL_BIS    = 10;  // px
var PAD_H_DESKTOP_BIS       = 8;   // px
var PAD_H_MOVIL_BIS         = 6;   // px

// ¿Sigue vigente?
function vigenteSegundaBis(){
  try { return (new Date()) <= (new Date(FECHA_FIN_SEGUNDA_BIS)); }
  catch(e){ return false; }
}

// ¿Pantalla pequeña?
function esPantallaPequenaBis() {
  return (window.innerWidth || document.documentElement.clientWidth) <= ANCHO_MOVIL_MAX_BIS;
}

// Crear badge (compacta en móvil)
function construirBadgeSegundaBis() {
  var esMovil = esPantallaPequenaBis();
  var chip = document.createElement('span');
  chip.className = CLASE_BADGE_SEG_BIS;
  chip.textContent = esMovil ? TEXTO_BADGE_MOVIL_BIS : TEXTO_BADGE_DESKTOP_BIS;

  var fontSize = esMovil ? TAM_FUENTE_MOVIL_BIS : TAM_FUENTE_DESKTOP_BIS;
  var padH     = esMovil ? PAD_H_MOVIL_BIS     : PAD_H_DESKTOP_BIS;

  chip.setAttribute('style',
    'display:inline-block;margin-left:6px;padding:2px ' + padH + 'px;' +
    'font-size:' + fontSize + 'px;line-height:18px;border-radius:999px;' +
    'background:#fdebd2;color:#8a4b00;border:1px solid #f7c99a;' +
    'font-weight:600;white-space:nowrap;vertical-align:middle;'
  );
  return chip;
}

// Inyectar badge
function ponerBadgeSegundaBis(ctx){
  if (!vigenteSegundaBis()) return;
  var raiz = ctx || document;
  var nodos = raiz.querySelectorAll(OBJETIVOS_BADGE_BIS);

  nodos.forEach(function(ancla){
    if (ancla.getAttribute(ATRIBUTO_INYECTADO_BIS) === '1') return;
    if (ancla.querySelector('.' + CLASE_BADGE_SEG_BIS)) {
      ancla.setAttribute(ATRIBUTO_INYECTADO_BIS, '1');
      return;
    }
    ancla.appendChild(construirBadgeSegundaBis());
    ancla.setAttribute(ATRIBUTO_INYECTADO_BIS, '1');
  });
}

// Reajustar badges al cambiar el tamaño (para alternar texto/medidas)
function recalcularBadgesSegundaBis(){
  if (!vigenteSegundaBis()) return;
  // Volver a pintar: eliminar y reinyectar para aplicar tamaño/texto móvil/desktop
  document.querySelectorAll('.' + CLASE_BADGE_SEG_BIS).forEach(function(b){ b.remove(); });
  document.querySelectorAll('[' + ATRIBUTO_INYECTADO_BIS + ']').forEach(function(n){ n.removeAttribute(ATRIBUTO_INYECTADO_BIS); });
  ponerBadgeSegundaBis(document);
}

// Bootstrap
function iniciarBadgesSegundaBis(){
  if (!vigenteSegundaBis()) return;

  // Primera pasada
  ponerBadgeSegundaBis(document);

  // Observar DOM dinámico
  var obsSegBis = new MutationObserver(function(muts){
    muts.forEach(function(m){
      if (m.addedNodes && m.addedNodes.length){
        m.addedNodes.forEach(function(n){
          if (n.nodeType === 1) ponerBadgeSegundaBis(n);
        });
      }
    });
  });
  obsSegBis.observe(document.body, {childList:true,subtree:true});

  // Reajustar en cambios de tamaño/orientación (desktop↔móvil)
  window.addEventListener('resize', recalcularBadgesSegundaBis, { passive:true });
  window.addEventListener('orientationchange', recalcularBadgesSegundaBis, { passive:true });
}

// Ejecutar si la promo está en fecha
if (vigenteSegundaBis()) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarBadgesSegundaBis);
  } else {
    iniciarBadgesSegundaBis();
  }
}

/* ocultar acordeones vacíos en product page */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-block-accordion .accordion-item').forEach(function(item) {
    var body = item.querySelector('.accordion-body');
    if (body && body.textContent.trim()) {
      item.classList.add('has-content');
    }
  });
});

document.querySelectorAll('.product-block-accordion .accordion-button').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var currentItem = btn.closest('.accordion-item');
    document.querySelectorAll('.product-block-accordion .accordion-item').forEach(function(item) {
      if (item !== currentItem) {
        var openCollapse = item.querySelector('.accordion-collapse.show');
        if (openCollapse) {
          var bsCollapse = bootstrap.Collapse.getInstance(openCollapse) || new bootstrap.Collapse(openCollapse);
          bsCollapse.hide();
        }
      }
    });
  });
});

/* ATC animado */
document.addEventListener('DOMContentLoaded', function () {
  const ATC_SELECTOR = '.btn-atc[name="add"]';
  const OVERLAY_SELECTOR = '.qsc2-overlay';
  const OVERLAY_HIDDEN_CLASS = 'qsc2-overlay--hidden';

  let loadingButton = null;
  let fallbackTimer = null;

  function startLoading(button) {
    if (!button) return;

    loadingButton = button;
    loadingButton.classList.add('fit-atc-loading');
    loadingButton.setAttribute('aria-busy', 'true');

    clearTimeout(fallbackTimer);

    fallbackTimer = setTimeout(function () {
      stopLoading();
    }, 8000);
  }

  function stopLoading() {
    if (!loadingButton) return;

    loadingButton.classList.remove('fit-atc-loading');
    loadingButton.removeAttribute('aria-busy');

    loadingButton = null;
    clearTimeout(fallbackTimer);
  }

  function isQscOverlayVisible() {
    const overlay = document.querySelector(OVERLAY_SELECTOR);
    return overlay && !overlay.classList.contains(OVERLAY_HIDDEN_CLASS);
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest(ATC_SELECTOR);

    if (!button) return;
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    startLoading(button);
  }, true);

  const observer = new MutationObserver(function () {
    if (isQscOverlayVisible()) {
      setTimeout(stopLoading, 150);
    }
  });

  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['class']
  });

  window.addEventListener('updated.ecomify.cart', function () {
    setTimeout(stopLoading, 150);
  });
});
/* ATC animado */
